import { useEffect, useState } from "react";
import { Hand } from "lucide-react";
import { useDemo } from "../../context/DemoContext";

const MODES = [
  { id: "peek", label: "Peek" },
  { id: "split", label: "Split" },
  { id: "expanded", label: "Expanded" },
];

const usePaused = (until) => {
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    const left = until - Date.now();
    if (left <= 0) return setPaused(false);
    setPaused(true);
    const t = setTimeout(() => setPaused(false), left);
    return () => clearTimeout(t);
  }, [until]);
  return paused;
};

export const ModeSwitch = () => {
  const { mode, setMode, setZoom, selected, setSelected, markInteraction, pausedUntil } = useDemo();
  const paused = usePaused(pausedUntil);
  const pick = (m) => {
    markInteraction();
    if (m !== "peek" && selected === "karna") setSelected("shashin");
    setZoom(false);
    setMode(m);
  };
  return (
    <div className="mt-5 flex flex-col items-center gap-2.5">
      <div className="glass glass-light flex rounded-full p-1" role="group" aria-label="Chat sheet position">
        {MODES.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => pick(m.id)}
            aria-pressed={mode === m.id}
            data-testid={`sheet-mode-${m.id}`}
            className={`h-9 rounded-full px-4 text-[13px] font-semibold transition-colors ${mode === m.id ? "bg-[#08090D] text-white" : "text-[#3c4052] hover:text-[#08090D]"}`}
          >
            {m.label}
          </button>
        ))}
      </div>
      <p className="flex items-center gap-1.5 text-[12px] text-[#777B8D]" data-testid="demo-status">
        <Hand size={13} aria-hidden />
        {paused ? "You're in control — scroll demo paused" : "Drag the handle, tap it, or pick a person"}
      </p>
      <p className="text-[11px] text-[#666a7d]">Sample content — fictional demo</p>
    </div>
  );
};
